//import logo from './images/logo.svg';
import logo from './images/jb_logo.gif';
import './App.css';
import { useState } from 'react';
import Anomaly from './components/ui/Anomaly';
import { calculateMAOP } from './utils/maopCalculations';
import { calculateFlowStress } from './utils/b31gCalculations';

function App() {
  const defaultSMYS = 24000;
  const defaultDesignFactor = 0.72;

  const [anomalies, setAnomalies] = useState([]);
  const [smys, setSmys] = useState(defaultSMYS);
  const [outsideDiameter, setOutsideDiameter] = useState('');
  const [defaultWallThickness, setDefaultWallThickness] = useState('');
  const [designFactor, setDesignFactor] = useState(defaultDesignFactor);
  const [flowStressMethod, setFlowStressMethod] = useState('plus10000');

  const flowStress = calculateFlowStress(smys, flowStressMethod);

  const maop = calculateMAOP(designFactor, smys, defaultWallThickness, outsideDiameter);

  const addAnomaly = () => {
    const newAnomaly = {
      id: Date.now(),
      description: '',
      depth: '',
      length: '',
      wallThickness: defaultWallThickness,
      measurementType: 'singleDepth'
    };
    setAnomalies([...anomalies, newAnomaly]);
  };

  const updateAnomaly = (id, field, value) => {
    setAnomalies(anomalies.map(anomaly =>
      anomaly.id === id ? { ...anomaly, [field]: value } : anomaly
    ));
  };

  const removeAnomaly = (id) => {
    setAnomalies(anomalies.filter(anomaly => anomaly.id !== id));
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>Basic Anomaly Calculations</h1>
      </header>
      <main className="App-main">
        <div className="input-row">
          <div className="form-group">
            <label htmlFor="smys">SMYS</label>
            <input
              id="smys"
              type="number"
              step="100"
              value={smys}
              onChange={(e) => setSmys(e.target.value)}
              placeholder="0.0"
            />
          </div>
          <div className="result-group">
            <label>Flow Stress</label>
            <span>{flowStress}</span>
          </div>
          <div className="form-group">
            <label htmlFor="outside-diameter">Outside Diameter</label>
            <input
              id="outside-diameter"
              type="number"
              step="0.01"
              value={outsideDiameter}
              onChange={(e) => setOutsideDiameter(e.target.value)}
              placeholder="0.0"
            />
          </div>
          <div className="form-group">
            <label htmlFor="default-wall-thickness">Default Wall Thickness</label>
            <input
              id="default-wall-thickness"
              type="number"
              step="0.01"
              value={defaultWallThickness}
              onChange={(e) => setDefaultWallThickness(e.target.value)}
              placeholder="0.0"
            />
          </div>
          <div className="form-group">
            <label htmlFor="design-factor">Design Factor</label>
            <input
              id="design-factor"
              type="number"
              step="0.01"
              value={designFactor}
              onChange={(e) => setDesignFactor(e.target.value)}
              placeholder="0.0"
            />
          </div>
          <div className="result-group">
            <label>MAOP</label>
            <span>{maop}</span>
          </div>
        </div>
        <div className="flow-stress-options">
          <label className="radio-label">
            <input
              type="radio"
              name="flowStress"
              value="plus10000"
              checked={flowStressMethod === 'plus10000'}
              onChange={() => setFlowStressMethod('plus10000')}
            />
            FS = SMYS + 10,000 psi
          </label>
          <label className="radio-label">
            <input
              type="radio"
              name="flowStress"
              value="times1_1"
              checked={flowStressMethod === 'times1_1'}
              onChange={() => setFlowStressMethod('times1_1')}
            />
            FS = 1.1 * SMYS
          </label>
        </div>
        <button className="add-button" onClick={addAnomaly}>
          + Add Anomaly
        </button>
        
        <div className="anomalies-container">
          {anomalies.length === 0 ? (
            <p className="no-anomalies">No anomalies added yet. Click "Add Anomaly" to get started.</p>
          ) : (
            anomalies.map((anomaly, index) => (
              <Anomaly
                key={anomaly.id}
                anomaly={anomaly}
                index={index}
                flowStress={flowStress}
                designFactor={designFactor}
                outsideDiameter={outsideDiameter}
                onUpdate={updateAnomaly}
                onRemove={removeAnomaly}
              />
            ))
          )}
        </div>
      </main>
    </div>
  );
}

export default App;
